<header class="splash__brand">
    <img class="splash__logo" src="/images/logo.png" alt="" />
    <span class="splash__name">RapiDocs</span>
</header>

<!-- A janela corta o artboard: as folhas ocupam pouco mais de um quarto dele, e
     sem o corte a pilha apareceria minúscula no meio de um quadrado vazio. -->
<div class="splash__window">
    <canvas #stage class="splash__stage" [class.is-drawing]="drawing()" aria-hidden="true"></canvas>
</div>

<!-- Uma letra por span para elas entrarem uma a uma. Quem ouve lê o rótulo do
     parágrafo, e não a soletração. -->
<p class="splash__hint" role="status" [attr.aria-label]="phrase()">
    @for (letter of letters(); track $index) {
        <span aria-hidden="true" [style.animation-delay.ms]="$index * letterDelay()">{{
            letter
        }}</span>
    }
</p>
